import React from "react";
import { Card, Skeleton } from "antd";
const LoadingCard = ({ cardClass }) => (
  <Card className={cardClass}>
    <Skeleton />
  </Card>
);
export default LoadingCard;
